<template>
  <div>
    <div class="flex flex-col items-center mb-10">
      <div
        class="size-[68px] bg-white border border-black/[8%] flex items-center justify-center rounded-full shadow-sm mb-[15px]"
      >
        <Icon name="Dacr" :size="46" />
      </div>

      <div
        class="font-semibold font-primary text-[36px] leading-[40px] text-gray-800 mb-[14px]"
      >
        Change your plan
      </div>

      <div
        class="font-secondary text-[18px] leading-[24px] text-gray-800 text-center"
      >
        Choose a plan that best suites your original work
      </div>
    </div>

    <SelectPlan :type="SelectPlanType.Change" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'
import SelectPlan from '@/features/billing/components/SelectPlan.vue'
import { SelectPlanType } from '@/shared/types/index'
</script>
